<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-cause" class="control-label">{{ inputLabel }}</label>
    <select
      v-model="inputValue"
      :disabled="disabled"
      :title="title"
      id="form-pass-cause"
      class="form-control"
      @input="emit"
      @change="emit"
      @blur="emit"
    >
      <option v-for="purpose in sortedItems" :key="purpose.id" :value="purpose.id">{{ purpose.name }}</option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'PassPurposeInput',

  components: { Hint },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Цель пребывания'
    },

    inputName: {
      default: 'application_group_purpose_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    typeaheadData: {
      type: Array,
      default: () => []
    }
  },

  created() {
    if (this.sortedItems.length === 1) {
      this.inputValue = this.sortedItems[0].id
    }
  },

  computed: {
    title() {
      return this.items.find(item => item.id === this.inputValue)?.name
    },

    sortedItems() {
      return (Object.values(this.items).sort((a, b) => a.sort - b.sort))
    },

    isCurrentPurposeVisible() {
      let current = (this.sortedItems).find((purpose) => purpose.id === this.inputValue)

      return current ? Number(current.visible) === 1 : true
    }
  },

  watch: {
    sortedItems(value) {
      if (value.length === 1) {
        this.inputValue = value?.[0]?.id
      }
    }
  }
}
</script>
